import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

// Schema
export const educationSchema = itemSchema.extend({
  institution: z.literal("").or(z.string().min(1)),
  studyType: z.string(),
  area: z.string(),
  score: z.string(),
  date: z.string(),
  startDate: z.string().optional().default(""),
  endDate: z.string().optional().default(""),
  isPresent: z.boolean().optional().default(false),
  summary: z.string(),
  url: urlSchema,
});

// Type
export type Education = z.infer<typeof educationSchema>;

// Defaults
export const defaultEducation: Education = {
  ...defaultItem,
  id: "",
  institution: "",
  studyType: "",
  area: "",
  score: "",
  date: "",
  startDate: "",
  endDate: "",
  isPresent: false,
  summary: "",
  url: defaultUrl,
};
